import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, ExternalLink } from 'lucide-react';
export function HomeScheduleLocation() {
  return <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-1776">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1777">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-1778">
          <div data-id="element-1779">
            <h2 className="text-4xl text-ink mb-3" data-id="element-1780">
              Class Times & Program Options
            </h2>
            <p className="text-gray-warm mb-8 leading-relaxed" data-id="element-1781">
              Storm will confirm the best class time for your child or family
              after you submit the form.
            </p>

            <div className="flex flex-col gap-3" data-id="element-1782">
              {[{
              title: 'Mini Troopers',
              audience: 'Ages 3-5',
              days: 'Monday-Friday',
              time: '4:30 PM - 5:00 PM'
            }, {
              title: 'Kids Taekwondo',
              audience: 'Ages 6+',
              days: 'Monday-Friday',
              time: '5:00 PM - 6:00 PM'
            }, {
              title: 'Kids Taekwondo / Family Class',
              audience: 'Ages 6+ and Adults',
              days: 'Monday-Friday',
              time: '6:00 PM - 7:00 PM'
            }, {
              title: 'Competition Team',
              audience: 'Advanced / Invitation Only',
              days: 'Monday, Wednesday, Friday',
              time: '7:00 PM - 9:00 PM'
            }, {
              title: 'Competition Team',
              audience: 'Advanced / Invitation Only',
              days: 'Saturday',
              time: '11:00 AM - 1:00 PM'
            }].map((block, idx) => <div key={idx} className="bg-off-white rounded-2xl border border-subtle-gray p-5 hover:border-storm-red/40 hover:shadow-sm transition-all" data-id="element-1783">
                  <div className="flex flex-wrap items-start justify-between gap-2 mb-2" data-id="element-1784">
                    <h3 className="text-lg text-ink m-0 leading-tight" data-id="element-1785">
                      {block.title}
                    </h3>
                    <span className="inline-block bg-storm-red/10 text-storm-red px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide whitespace-nowrap" data-id="element-1786">
                      {block.audience}
                    </span>
                  </div>
                  <p className="text-sm text-gray-warm mb-1" data-id="element-1787">{block.days}</p>
                  <p className="font-display text-xl text-ink tracking-wide" data-id="element-1788">
                    {block.time}
                  </p>
                </div>)}
            </div>

            <p className="text-xs text-gray-warm mt-4 italic" data-id="element-1789">
              Class times may change. Storm will confirm the best class time
              before your first visit.
            </p>

            <Link to="/SignMeUp" className="btn-primary w-full sm:w-auto mt-6" data-id="element-1790">
              Check Availability
            </Link>
          </div>
          <div data-id="element-1791">
            <h2 className="text-4xl text-ink mb-6" data-id="element-1792">
              Taekwondo Classes in Farmington Hills, Serving Novi, Commerce,
              Livonia & Nearby Areas
            </h2>
            <p className="text-lg text-gray-warm mb-8 leading-relaxed" data-id="element-1793">
              Storm Taekwondo is located at 24786 Crestview, Farmington Hills,
              Michigan 48335. Families visit from Farmington Hills, Novi,
              Commerce, Livonia, Farmington, Northville, Waterford, and
              surrounding Southeast Michigan communities.
            </p>

            <div className="bg-paper rounded-2xl shadow-soft border border-subtle-gray overflow-hidden flex flex-col" data-id="element-1794">
              <div className="p-8 flex flex-col gap-6" data-id="element-1795">
                <div data-id="element-1796">
                  <p className="font-display text-2xl text-ink tracking-wide mb-4" data-id="element-1797">
                    Storm Taekwondo
                  </p>
                  <div className="flex items-start gap-4 mb-4" data-id="element-1798">
                    <div className="w-11 h-11 bg-off-white rounded-xl flex items-center justify-center shrink-0 text-storm-red" data-id="element-1799">
                      <MapPin className="w-5 h-5" data-id="element-1800" />
                    </div>
                    <div data-id="element-1801">
                      <p className="text-ink font-bold" data-id="element-1802">24786 Crestview</p>
                      <p className="text-gray-warm" data-id="element-1803">
                        Farmington Hills, Michigan 48335
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4" data-id="element-1804">
                    <div className="w-11 h-11 bg-off-white rounded-xl flex items-center justify-center shrink-0 text-storm-red" data-id="element-1805">
                      <Phone className="w-5 h-5" data-id="element-1806" />
                    </div>
                    <div data-id="element-1807">
                      <p className="text-xs font-bold uppercase tracking-wide text-gray-warm" data-id="element-1808">
                        Phone
                      </p>
                      <a href="tel:517-220-0621" className="text-ink font-bold hover:text-storm-red transition-colors" data-id="element-1809">
                        517-220-0621
                      </a>
                    </div>
                  </div>
                </div>

                <div className="pt-6 border-t border-subtle-gray" data-id="element-1810">
                  <p className="text-xs font-bold uppercase tracking-wide text-gray-warm mb-3" data-id="element-1811">
                    Service Areas
                  </p>
                  <div className="flex flex-wrap gap-2" data-id="element-1812">
                    {['Farmington Hills', 'Novi', 'Commerce', 'Livonia', 'Farmington', 'Northville', 'Waterford', 'Southeast Michigan'].map(area => <span key={area} className="inline-block bg-off-white text-ink border border-subtle-gray px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-1813">
                        {area}
                      </span>)}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 pt-2" data-id="element-1814">
                  <a href="tel:517-220-0621" className="btn-secondary w-full sm:flex-1 text-center" data-id="element-1815">
                    <Phone className="w-5 h-5 mr-2" data-id="element-1816" />
                    Call 517-220-0621
                  </a>
                  <Link to="/SignMeUp" className="btn-primary w-full sm:flex-1 text-center" data-id="element-1817">
                    Start With a Trial Class
                  </Link>
                </div>
              </div>

              {/* Google Maps Embed */}
              <div className="h-64 relative border-t border-subtle-gray bg-ink" data-id="element-1818">
                <iframe title="Storm Sport Taekwondo on Google Maps" src="https://www.google.com/maps?q=24786+Crestview,+Farmington+Hills,+MI+48335&output=embed" width="100%" height="100%" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen className="absolute inset-0 w-full h-full border-0" data-id="element-1819" />
                <a href="https://www.google.com/maps/search/?api=1&query=Storm+Sport+Taekwondo+24786+Crestview+Farmington+Hills+MI+48335" target="_blank" rel="noopener noreferrer" aria-label="Open 24786 Crestview, Farmington Hills, MI 48335 in Google Maps" className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-storm-red hover:bg-storm-red-dark text-white text-xs font-bold uppercase tracking-wide px-3 py-2 rounded-full shadow-lg transition-colors z-10" data-id="element-1820">
                  Open in Maps
                  <ExternalLink className="w-3.5 h-3.5" data-id="element-1821" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}